import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getEquipmentByEquipTypeForBuilding,
  getEquipmentByFloorAndPointType,
} from '../../../redux/selectors/equipment';
import { fetchEquipForBuildingActionCreator } from '../../../redux/actions/equipment';
import { isBuildingLoading } from '../../../redux/selectors/ui';
import {
  setBackButtonLabel,
  setResultsViewType,
  setLocationDisplayOption,
  setBackButtonLinkAction,
} from '../../../redux/actions/ui';
import EquipTypeView from './EquipTypeView';
import EquipTypeByFloorView from './EquipTypeByFloorView';
import { getSearchParams } from '../../../utils/url';
import '../Explore.css';

const mapStateToProps = (state, ownProps) => ({
  equipmentTypes: getEquipmentByEquipTypeForBuilding(state, {
    ...getSearchParams(ownProps.location.search),
    hideChild: false,
  }),
  equipmentTypesByFloor: getEquipmentByFloorAndPointType(state, {
    ...getSearchParams(ownProps.location.search),
    hideChild: false,
  }),
  jwt: state.user.jwt,
  buildingIsFetchingData: isBuildingLoading(state, ownProps.bid),
  byLocDisplayOption: state.ui.byLocDisplayOption,
});

const mapDispatchToProps = (dispatch) => ({
  getEquipmentForBuilding: (buildingId, jwt, getPoints) =>
    dispatch(fetchEquipForBuildingActionCreator(buildingId, jwt, getPoints)),
  setBackButtonLabel: (label) => dispatch(setBackButtonLabel(label)),
  setResultsViewType: (type) => dispatch(setResultsViewType(type)),
  setLocationDisplayOption: (option) => dispatch(setLocationDisplayOption(option)),
  setBackButtonLink: (link) => dispatch(setBackButtonLinkAction(link)),
});

export class EquipTypeContainerUnconnected extends Component {
  componentDidMount() {
    this.props.setBackButtonLabel('< BACK TO PORTFOLIO VIEW');
    this.props.setBackButtonLink('/explore/buildings');
    this.props.setResultsViewType('EquipType');
    this.getEquipment();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.bid === this.props.bid &&
      prevProps.equipmentTypes.length === this.props.equipmentTypes.length &&
      JSON.stringify(prevProps.equipmentTypes) === JSON.stringify(this.props.equipmentTypes)
    ) {
      return;
    }
    this.getEquipment();
  }

  componentWillUnmount() {
    this.props.setBackButtonLabel(null);
    this.props.setResultsViewType('');
    this.props.setLocationDisplayOption('flow');
  }

  getEquipment() {
    if (!this.props.bid) return;
    this.props.getEquipmentForBuilding(this.props.bid, this.props.jwt, true).catch((error) => {
      // eslint-disable-next-line no-console
      console.log(`Error with GET to /buildings/${this.props.bid}/equipment: ${error.message}`);
    });
  }

  render() {
    const handleSelection = (e, equipType, floorNum) => {
      let queryString = `?bid=${this.props.bid}&etid=${equipType.instances[0].typeId}`;
      if (this.props.byLocDisplayOption === 'physlocation') {
        queryString += `&floorPhys=${floorNum}`;
      } else if (this.props.byLocDisplayOption === 'areaserved') {
        queryString += `&floorServed=${floorNum}`;
      }
      if (equipType.nameAbbr === 'CHWS' || equipType.nameAbbr === 'HWS') {
        queryString += '&inclChild=true';
      }
      const url = `${this.props.location.pathname}/${encodeURIComponent(
        equipType.nameLong
      )}${queryString}`;
      this.props.navigate(url);
    };
    if (
      this.props.byLocDisplayOption === 'physlocation' ||
      this.props.byLocDisplayOption === 'areaserved'
    ) {
      return (
        <EquipTypeByFloorView
          equipmentTypesByFloor={this.props.equipmentTypesByFloor}
          buildingIsFetchingData={this.props.buildingIsFetchingData}
          handleSelection={(e, equipType, floorNum) => handleSelection(e, equipType, floorNum)}
        />
      );
    }
    return (
      <EquipTypeView
        equipmentTypes={this.props.equipmentTypes}
        buildingIsFetchingData={this.props.buildingIsFetchingData}
        handleSelection={(e, equipType) => handleSelection(e, equipType)}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipTypeContainerUnconnected);
